import { render, staticRenderFns } from "./OperationPhotoMatchTags.vue?vue&type=template&id=282f3ef0&scoped=true&"
import script from "./OperationPhotoMatchTags.vue?vue&type=script&lang=js&"
export * from "./OperationPhotoMatchTags.vue?vue&type=script&lang=js&"
import style0 from "./OperationPhotoMatchTags.vue?vue&type=style&index=0&id=282f3ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f3ef0",
  null
  
)

export default component.exports